import * as React from 'react'
import { PlaceholderProps, components } from 'react-select'
import { TSkillOption } from '../skill-select.types'

export const Placeholder = (props: PlaceholderProps<TSkillOption, true>) => (
  <components.Placeholder {...props} className="text-grey-600 mx-0" />
)
